import { useAnalyticsContext } from "shared-utils";

import { analytics } from "../../analytics";

const useMagentoClickHandler = (analyticsContext) => {
  return () => {
    analytics.requestedMagentoAccessTokenInstructions(analyticsContext);
    window.open("https://wayflyer.com/support/connect/magento");
  };
};

const useBigCommerceClickHandler = (analyticsContext) => {
  return () => {
    analytics.requestedBigCommerceAccessTokenInstructions(analyticsContext);
    window.open("https://wayflyer.com/support/connect/bigcommerce");
  };
};

const usePrestaShopClickHandler = (analyticsContext) => {
  return () => {
    analytics.requestedPrestaShopWebserviceKeyInstructions(analyticsContext);
    window.open("https://wayflyer.com/support/connecting-platforms");
  };
};

const useShopware5ClickHandler = (analyticsContext) => {
  return () => {
    analytics.requestedShopware5AccessTokenInstructions(analyticsContext);
    window.open("https://wayflyer.com/support/connecting-platforms");
  };
};

/**
 * Provides re-usable click handler to open the appropriate modal help
 */
export const useConnectorHelpClickHandlers = () => {
  const analyticsContext = useAnalyticsContext();
  return {
    magento: useMagentoClickHandler(analyticsContext),
    bigcommerce: useBigCommerceClickHandler(analyticsContext),
    shopware5: useShopware5ClickHandler(analyticsContext),
    prestashop: usePrestaShopClickHandler(analyticsContext),
  };
};
